export function removeEmptyValues(values: any): any {
  const cleanedValues: any = {};

  for (const key in values) {
    const value = values[key];
    
    if (value !== null && value !== undefined) {
      cleanedValues[key] = value;
    }
  }

  return cleanedValues;
}
